<template>
  <div class="d-flex justify-center align-center" style="min-height: 100vh; background: #f5f5f5;">
    <v-card width="400" class="pa-6">
      <v-card-title class="text-h5 text-center"><h1 class="text-h5">Forget Password</h1></v-card-title>

      <v-form ref="form" @submit.prevent="handleSubmit">
        <v-text-field
          v-model="email"
          type="email"
          label="Email"
          :rules="emailRule"
          class="mb-4"
          required
        />

        <v-btn type="submit" color="primary" block>
          Send Reset Link
        </v-btn>
      </v-form>
    </v-card>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import {  forgetPassword } from '@/services/entityService'
import { usePathController } from '@/composables/usePathController'
import { useLoaderStore } from "@/store/loader"
const { goToLogin, goTo  } = usePathController()
const route = useRoute()
const loader = useLoaderStore()
const form = ref(null)

const emailRule = [
  v => !!v || 'Email is required',
  v => /.+@.+\..+/.test(v) || 'Email must be valid'
]

const email = ref('')

const handleSubmit = async () => {
  const { valid } = await form.value.validate()
  if (!valid) return

  try {
    await forgetPassword(email.value)

  } catch (err) {
    loader.setAlert( { 
      message: err.message,
      type:"error", 
      timeout: 5000 
    });
  } finally{
    loader.setAlert({ message: "Reset link sent to your email", color: "green", timeout: 5000 });
    goToLogin()
  }
}
</script>